import { useEffect, useState } from 'react';
import { ResetPassword } from '../ResetPassword/ResetPassword';
import { useAppTranslations } from '../../hooks';
import { ResetPIN } from '../ResetPIN';

interface WelcomeModalProps {
  passwordChange: boolean;
  email?: string;
  id?: number;
}

export const WelcomeModal = ({ passwordChange, email, id }: WelcomeModalProps) => {
  const [showResetPassword, setShowResetPassword] = useState(false);
  const {
    MODAL_HIDE_PIN,
    MODAL_SHOW_PIN,
    RESET_ACCORDION_CONTENT_PARAGRAPH_1,
    RESET_ACCORDION_CONTENT_PARAGRAPH_2,
    RESET_ACCORDION_TITLE,
    RESET_CONFIRM,
    RESET_CONFIRM_PASSWORD_PLACEHOLDER,
    RESET_LOADING_SUBTITLE,
    RESET_LOADING_TITLE,
    RESET_MODAL_BODY_SUBTITLE,
    RESET_MODAL_BODY_SUBTITLE_STRONG,
    RESET_MODAL_BODY_TITLE,
    RESET_MODAL_CLOSE,
    RESET_MODAL_TITLE,
    RESET_PASSWORD_PLACEHOLDER,
    RESET_PIN_ACCORDION_CONTENT_PARAGRAPH_1,
    RESET_PIN_ACCORDION_CONTENT_PARAGRAPH_2,
    RESET_PIN_ACCORDION_TITLE,
    RESET_PIN_CONFIRM,
    RESET_PIN_LOADING_SUBTITLE,
    RESET_PIN_MODAL_BODY_SUBTITLE_STRONG,
    RESET_PIN_SUCCESS_BODY_TITLE,
    RESET_PIN_VALIDATION_CONSECUTIVE,
    RESET_PIN_VALIDATION_NUMBERS,
    RESET_PIN_VALIDATION_REPEAT,
    RESET_PIN_VALIDATION_TITLE,
    RESET_SUCCESS_BODY_SUBTITLE,
    RESET_SUCCESS_BODY_TITLE,
    RESET_SUCCESS_CONFIRM,
    RESET_SUCCESS_TITLE,
    RESET_VALIDATION_LOWER_UPPER,
    RESET_VALIDATION_MIN_LENGTH,
    RESET_VALIDATION_NUMBER,
    RESET_VALIDATION_SYMBOL,
    RESET_VALIDATION_TITLE,
  } = useAppTranslations();

  useEffect(() => {
    passwordChange && setShowResetPassword(true);
  }, []);

  const resetProps = {
    emailProps: {
      email: email!,
      id: id!,
      modalClose: RESET_MODAL_CLOSE,
      modalTitle: RESET_MODAL_TITLE,
      modalBodyTitle: RESET_MODAL_BODY_TITLE,
      modalBodySubtitle: RESET_MODAL_BODY_SUBTITLE,
      modalBodySubtitleStrong: RESET_MODAL_BODY_SUBTITLE_STRONG,
      passwordPlaceholder: RESET_PASSWORD_PLACEHOLDER,
      validationTitle: RESET_VALIDATION_TITLE,
      validationMinLengthLabel: RESET_VALIDATION_MIN_LENGTH,
      validationLowerUpperLabel: RESET_VALIDATION_LOWER_UPPER,
      validationNumberLabel: RESET_VALIDATION_NUMBER,
      validationSymbolLabel: RESET_VALIDATION_SYMBOL,
      confirmPasswordPlaceholder: RESET_CONFIRM_PASSWORD_PLACEHOLDER,
      accordionTitle: RESET_ACCORDION_TITLE,
      accordionContentParagraph1: RESET_ACCORDION_CONTENT_PARAGRAPH_1,
      accordionContentParagraph2: RESET_ACCORDION_CONTENT_PARAGRAPH_2,
      resetConfirm: RESET_CONFIRM,
      success: {
        modalTitle: RESET_SUCCESS_TITLE,
        modalBodyTitle: RESET_SUCCESS_BODY_TITLE,
        modalBodySubtitle: RESET_SUCCESS_BODY_SUBTITLE,
        modalConfirm: RESET_SUCCESS_CONFIRM,
      },
      loading: {
        modalTitle: RESET_LOADING_TITLE,
        modalBodySubtitle: RESET_LOADING_SUBTITLE,
      },
    },
    pinProps: {
      showLabel: MODAL_SHOW_PIN,
      hideLabel: MODAL_HIDE_PIN,
      id: id!,
      modalClose: RESET_MODAL_CLOSE,
      modalTitle: RESET_MODAL_TITLE,
      modalBodyTitle: RESET_MODAL_BODY_TITLE,
      modalBodySubtitle: RESET_MODAL_BODY_SUBTITLE,
      modalBodySubtitleStrong: RESET_PIN_MODAL_BODY_SUBTITLE_STRONG,
      validationTitle: RESET_PIN_VALIDATION_TITLE,
      validationNumbersLabel: RESET_PIN_VALIDATION_NUMBERS,
      validationConsecutiveLabel: RESET_PIN_VALIDATION_CONSECUTIVE,
      validationRepeatLabel: RESET_PIN_VALIDATION_REPEAT,
      accordionTitle: RESET_PIN_ACCORDION_TITLE,
      accordionContentParagraph1: RESET_PIN_ACCORDION_CONTENT_PARAGRAPH_1,
      accordionContentParagraph2: RESET_PIN_ACCORDION_CONTENT_PARAGRAPH_2,
      resetConfirm: RESET_PIN_CONFIRM,
      success: {
        modalTitle: RESET_SUCCESS_TITLE,
        modalBodyTitle: RESET_PIN_SUCCESS_BODY_TITLE,
        modalBodySubtitle: RESET_SUCCESS_BODY_SUBTITLE,
        modalConfirm: RESET_SUCCESS_CONFIRM,
      },
      loading: {
        modalTitle: RESET_LOADING_TITLE,
        modalBodySubtitle: RESET_PIN_LOADING_SUBTITLE,
      },
    },
  };

  return showResetPassword ? (
    <ResetPassword {...resetProps.emailProps} />
  ) : (
    <ResetPIN {...resetProps.pinProps} />
  );
};
